export const albumCovers = [
  {
    id:1,
    name: "Snap My Fingers",
    artist: "Kaytranada",
    url:"https://upload.wikimedia.org/wikipedia/en/thumb/1/17/Album_cover_for_Timeless_by_Kaytranada.webp/316px-Album_cover_for_Timeless_by_Kaytranada.webp.png"
  }
];
